import { buildAPIUrl, responseInterceptor } from './index';

export interface ComingSoonReport {
  reportId: string;
  title: string;
  type: string;
  directory: string;
  publishDate: string;
  text?: string;
  isSubscribed: boolean;
}

export interface ComingSoonWeek {
  month: string;
  firstDayOfWeek: string;
  reports: ComingSoonReport[];
}

export interface ComingSoonData {
  text: string;
  comingSoonByDates: {
    comingSoonReports: ComingSoonWeek[];
  };
  directorySubscriptions?: Array<{
    directoryId: string;
    directoryName: string;
  }>;
}

export interface ComingSoonParams {
  userId: string;
  culture: string;
  directoryIds?: string[];
}

export const getComingSoonReports = async (params: ComingSoonParams): Promise<ComingSoonData> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ComingSoonReports/GetComingSoonReports`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }),
  );
  return response.json();
};

export const subscribeToReport = async (reportId: string): Promise<void> => {
  await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ComingSoonSubscriptions/SubscribeToReport?reportId=${reportId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }),
  );
};

export const unsubscribeFromReport = async (reportId: string): Promise<void> => {
  await responseInterceptor(
    await fetch(
      `${await buildAPIUrl()}/umbraco/Api/ComingSoonSubscriptions/UnSubscribeFromReport?reportId=${reportId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    ),
  );
};
